import { toggleMark } from 'prosemirror-commands';
import { Mark } from 'prosemirror-model';
import { CommandProps } from '../types';
import { BaseMark } from './base/BaseMark';

export class Strong extends BaseMark {
  constructor() {
    super('strong');
  }

  get schema() {
    return {
      parseDOM: [
        { tag: 'strong' },
        { tag: 'b', getAttrs: (node: HTMLElement) => node.style.fontWeight != 'normal' && null },
        { style: 'font-weight=400', clearMark: (m: Mark) => m.type.name == 'strong' },
        {
          style: 'font-weight',
          getAttrs: (value: string) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
        },
      ],
      toDOM() {
        return ['strong', 0] as const;
      },
    };
  }

  commands({ schema }: CommandProps) {
    return {
      'Mod-b': toggleMark(schema.marks.strong),
    };
  }
}
